import script from "./DeleteAccountConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccountConfirm.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccountConfirm.vue?vue&type=style&index=0&id=4327dff4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4327dff4"]])

export default __exports__